module.exports = __webpack_public_path__ + "img/garden.50e7a0bd.svg";